import {useListView} from '../core/ListViewProvider'
import {AgencyListToolbar} from './AgencyListToolbar'
import {AgencyListGrouping} from './AgencyListGrouping'
import {AgencyListSearchComponent} from './AgencyListSearchComponent'

const AgencyListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <AgencyListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <AgencyListGrouping /> : <AgencyListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {AgencyListHeader}
